module.exports = __webpack_public_path__ + "img/stability3.a81c3653.png";